import classNames from "components/ui/classNames";

export default function WholeIssuerPageSkeleton() {
  return (
    <div>
      <div className="absolute top-0 z-0 w-full border-b-2 border-b-brand/20">
        <div
          className={classNames("h-[384px] w-full animate-pulse", {
            "bg-gradient-to-b from-brand/40 to-sky-100": true,
          })}
        />
      </div>

      <div className="mx-auto max-w-7xl space-y-8 px-4 pb-16 xl:px-0">
        <div className="relative mt-16 space-y-8 rounded-xl bg-white px-4 pb-8 pt-8 shadow xl:mt-32">
          <div className="px-4">
            <div className="space-y-8">
              <div className="space-y-2">
                <div className="flex items-center">
                  <div className="m-0 block h-12 w-52 animate-pulse rounded-xl bg-slate-200" />
                </div>

                <div className="space-x-2">
                  <span className="inline-flex h-3 w-12 animate-pulse rounded-md bg-slate-200" />
                  <span className="inline-flex h-3 w-12 animate-pulse rounded-md bg-slate-200" />
                </div>

                <div className="absolute right-8 top-8 block h-12 w-12 bg-slate-200 squircle" />
              </div>

              <div className="flex flex-col space-y-1">
                <div className="inline-flex h-3 w-5/6 animate-pulse rounded-md bg-slate-200" />
                <div className="inline-flex h-3 w-5/12 animate-pulse rounded-md bg-slate-200" />
                <div className="inline-flex h-3 w-6/12 animate-pulse rounded-md bg-slate-200" />
              </div>

              <div className="flex h-24 w-4/12 flex-col rounded-md bg-slate-100" />

              <div className="space-y-2">
                <div className="inline-flex h-3 w-36 animate-pulse rounded-md bg-slate-200" />
                <div className="flex flex-col space-y-2 xl:flex-row xl:space-x-2 xl:space-y-0">
                  <div className="h-8 w-full animate-pulse rounded-md bg-slate-200 md:w-36" />
                  <div className="h-8 w-full animate-pulse rounded-md bg-slate-200 md:w-36" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 items-center gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
        </div>

        <div className="grid grid-cols-1 items-center gap-y-6">
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
          <div className="h-24 w-full animate-pulse rounded-xl bg-slate-100 ring-2 ring-slate-200 ring-offset-2 ring-offset-white" />
        </div>
      </div>
    </div>
  );
}
